// removed by extract-text-webpack-plugin
module.exports = {"product":"product","product-status":"product-status","status-waiting":"status-waiting","status-refuse":"status-refuse","status-success":"status-success","wrap-img":"wrap-img","product-wrap-detail":"product-wrap-detail","product-image":"product-image","name":"name","name-link":"name-link","price":"price","sale-price":"sale-price","price-old":"price-old","sale-percent":"sale-percent","price-sale":"price-sale","price-throught":"price-throught","description":"description","company-name":"company-name","send-request":"send-request","add-to-cart":"add-to-cart"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/style.scss
// module id = ./components/partials/product/style.scss
// module chunks = 0